/*
 * TwoPaneLayout verifies that the user has access to this feature, then either shows the component or lets them know they do not have access
 */

import * as React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Iuser } from '../../models';
import { Route, RouteComponentProps, Switch } from 'react-router-dom';
import ManageInventory from '../manageInventory/ManageInventory';
import ManageJobComment from '../manageJobComment/ManageJobComment';
import ManageLocation from '../manageLocation/ManageLocation';
import { MeasurementPointListLayout } from '../measurementPointList/MeasurementPointListLayout';
// mounted here rather than App.tsx: importing the results actions that early pulls
// measurementPointListsReducer before manageInventoryReducer finishes initialising
import { OpenRepairConflictWatcher } from '../measurementPointList/OpenRepairConflictWatcher';
import { SimpleMeasurementPointListLayout } from '../measurementPointList/SimpleMeasurementPoint/SimpleMeasurementPointListLayout';
import ManageWorkOrder from '../manageWorkOrder/ManageWorkOrder';
import { QuotePartCartLayout } from '../parts/QuotePartCartLayout';
import Dashboard from '../dashboard/Dashboard';
import SuggestedPartsLayout from '../parts/SuggestedParts';
import { setLocationPathname } from '../../actions/commonActions';
import { connect } from 'react-redux';
import { constants } from '../../constants/constants';
import { IinitialState } from '../../reducers';
import Mixpanel from '../../helpers/Mixpanel';

interface Iprops extends RouteComponentProps<any> {
    user: Iuser;
    setLocationPathname: typeof setLocationPathname;
}

class TwoPaneLayout extends React.PureComponent<Iprops, Record<string, never>> {
    tile = constants.getTileByURL(this.props.location.pathname);
    hasAccess = constants.hasSecurityFunction(this.props.user, this.tile.securityFunction);

    componentDidMount() {
        this.props.setLocationPathname(this.props.location?.pathname ?? '');
    }

    componentDidUpdate(prevProps: Iprops) {
        if (this.props.location.pathname !== prevProps.location.pathname) {
            this.props.setLocationPathname(this.props.location?.pathname ?? '');
        }
    }

    render() {
        Mixpanel.track(`Viewed ${this.tile.title}`, {
            hasAccess: this.hasAccess
        });
        Mixpanel.identify(this.props.user.id);
        Mixpanel.people.set({
            $email: this.props.user.email,
            USER_ID: this.props.user.id
        });

        if (!this.hasAccess) {
            return (
                <Container className="two-pane-layout modal-container" id="two-pane-layout" fluid={true}>
                    <Row>
                        <Col className="col-fluid">
                            <div style={{ padding: '20px' }}>
                                {' '}
                                <h4>No access to {this.tile.title}. Please contact support and request access.</h4>{' '}
                            </div>
                        </Col>
                    </Row>
                </Container>
            );
        }

        return (
            <Container className="two-pane-layout modal-container" id="two-pane-layout" fluid={true}>
                <Row>
                    <Col data-path={this.props.location.pathname}>
                        <Switch>
                            <Route exact path="/devices" component={ManageInventory} />
                            <Route exact path="/devices/:installID" component={MeasurementPointListLayout} />
                            <Route exact path="/suggested_parts/:installID" component={SuggestedPartsLayout} />
                            <Route exact path="/jobs" component={Dashboard} />
                            <Route exact path="/job_comments" component={ManageJobComment} />
                            <Route exact path="/maintenance" component={ManageWorkOrder} />
                            <Route exact path="/repair" component={ManageInventory} />
                            <Route exact path="/commission" component={ManageInventory} />
                            <Route exact path="/quote_part_cart" component={QuotePartCartLayout} />
                            <Route exact path="/warranty" component={ManageInventory} />
                            <Route exact path="/locations" component={ManageLocation} />
                            <Route exact path="/simple_list" component={SimpleMeasurementPointListLayout} />
                            <Route exact path="/dashboard" component={Dashboard} />
                        </Switch>
                        <OpenRepairConflictWatcher />
                    </Col>
                </Row>
            </Container>
        );
    }
}

const mapStateToProps = (state: IinitialState, ownProps: any) => {
    return {
        user: state.user
    };
};

export default connect(mapStateToProps, { setLocationPathname })(TwoPaneLayout);
